import { render, staticRenderFns } from "./GamesManagementBody.vue?vue&type=template&id=3aa5626e&scoped=true&"
import script from "./GamesManagementBody.vue?vue&type=script&lang=ts&"
export * from "./GamesManagementBody.vue?vue&type=script&lang=ts&"
import style0 from "./GamesManagementBody.vue?vue&type=style&index=0&id=3aa5626e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5626e",
  null
  
)

export default component.exports